import request from '../utils/request'

export function getConfigValue(params) {
  return request({
    url: '/index/config/getConfigValue',
    method: 'get',
    params
  })
}

export function getIndexConfig() {
  return request({
    url: '/index/config/getIndexConfig',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/config.js